import { Select } from 'foundations-components/components/Select';
import { Box } from 'foundations-components/transitional/components/Box';
import { trackDdgUsageEvents } from '../utils/usageTracking';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Small } from 'foundations-components/transitional/components/Small';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { HUB_LEVELS, HUBS } from '../constants/hubsAndFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function HubLevelSelector({
  parcelsUpdate,
  onChange
}) {
  const hubLevelOptions = HUB_LEVELS.map(level => ({
    text: unescapedText(`partnerDemoPortalUi.hubs.levels.${level}`),
    value: level
  }));
  return /*#__PURE__*/_jsx(FormControl, {
    marginBlockEnd: "500",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "partnerDemoPortalUi.hubs.title"
    }),
    help: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "partnerDemoPortalUi.hubs.help"
    }),
    children: /*#__PURE__*/_jsx(TFlex, {
      direction: "column",
      align: "stretch",
      gap: 10,
      paddingBlock: "300",
      children: HUBS.map(parcelKey => /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        justify: "between",
        children: [/*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `partnerDemoPortalUi.hubs.options.${parcelKey}`
            })
          })
        }), /*#__PURE__*/_jsx(Box, {
          inlineSize: "160px",
          children: /*#__PURE__*/_jsx(Select, {
            options: hubLevelOptions,
            selectedValues: parcelsUpdate[parcelKey] ? [parcelsUpdate[parcelKey]] : [],
            onSelectedOptionChange: evt => {
              const level = evt.value || 'ENTERPRISE';
              trackDdgUsageEvents({
                action: 'hub-level-changed',
                screen: 'demo-data-generator',
                hub: parcelKey,
                level
              });
              onChange(Object.assign({}, parcelsUpdate, {
                [parcelKey]: level
              }));
            }
          })
        })]
      }, parcelKey))
    })
  });
}